$(document).ready(function() {

	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	$('.investors__slider').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 8,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true, 
		autoplaySpeed: 1000,
		rtl: dirRtlFlag,
		responsive: [{
				breakpoint: 1600,
				settings: {
					slidesToShow: 7,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 1400,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 1200,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 375,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.prev-part').click(function() {
		$('.investors__slider').slick('slickPrev');
		return false;
	});

	$('.next-part').click(function() {
		$('.investors__slider').slick('slickNext');
		return false;
	});

})